import { useMemo } from 'react';
import useValueList from '../../../hook/useValueList';
import { IValueInfo } from '../../../types/valuelist';

const getParentType = (childType?: string) => {
  switch (childType) {
    case 'ACCS_COMM_TYPE_CODE':
    case 'ACCS_LOC_TYPE_CODE':
      return 'ACCS_CAT_CODE';

    case 'CITY':
    case 'ORG_PREFIX':
      return 'PROVINCE';

    case 'PROVINCE':
      return 'COUNTRY';

    case 'ORG_CATEGORY':
    case 'ORG_CATEGORY_FR':
      return 'ORG_CLASSIFICATION';

    case 'ORG_TYPE':
    case 'ORG_TYPE_FR':
      return 'ORG_CATEGORY';

    default:
      return undefined;
  }
};

const getDefaultParentCode = (parentType?: string) => {
  switch (parentType) {
    case 'PROVINCE':
      return 'ON';

    case 'COUNTRY':
      return 'CA';

    default:
      return undefined;
  }
};

export default function useParentValue(type?: string): [
  string?, // parent type
  IValueInfo[]?, // parent value list
  number?, // default parent code
] {
  const parentType = getParentType(type);

  const [parentValueList] = useValueList(parentType);

  const defaultParentId = useMemo(() => {
    const defaultCode = getDefaultParentCode(parentType);
    return parentValueList.find(v => v.code === defaultCode)?.id ?? 0;
  }, [parentType, parentValueList]);

  return [parentType, parentValueList, defaultParentId];
}
